import defaultBlankString from "./defaultBlankString.function";

export default function undefineBlankString(string: string | null | undefined): string | undefined {
  return defaultBlankString(string, undefined);
}
